import { useEffect } from 'react' 

const defaultSpy = ({target, extra_top = 0, onEntered, onExited}, { current }, { main, isScrollDown, isScrollUp, isInitial }) => {
    if(!target) return;
    const { y } = target.getBoundingClientRect()
    const targetPosition = current.y + y
    const windowPosition = current.y + extra_top 

    if(onEntered && (isScrollDown || isInitial) && windowPosition >= targetPosition) onEntered(windowPosition) 
    
    else if(onExited && (isScrollUp || isInitial) && windowPosition < targetPosition) onExited(windowPosition)
    main.scrollTop = current.y
}

export const useScrollPosition = (callback, scrolled) => { 
    
    useEffect(() => {
        const root = scrolled ? 
            typeof scrolled === 'string' ?  
                document.querySelector(scrolled)
                : scrolled
            : document.documentElement
        let previous = { x: root.scrollLeft, y: root.scrollTop }
        const scrollC = () => {

            const {scrollLeft, scrollTop } = root
            const { innerHeight, innerWidth } = window
            const current = {x: scrollLeft, y: scrollTop}

            callback({current, previous}, { isInitial: previous.y === current.y,isScrollDown: current.y > previous.y, isScrollUp: current.y < previous.y, screen: { innerHeight, innerWidth }, defaultSpy, main: root})
            
            previous = current
        }
        ( scrolled ? root : window).addEventListener('scroll', scrollC)
        
        return () => ( scrolled ? root : window).removeEventListener('scroll', scrollC)
    })
}